import {post,get} from '../libs/ajax.js';

export default {
    // 部门tree
    getTree: (data, options) => {
        return get('/group/get_tree', data, options)
    },
    // 获取部门信息
    getInfo: (data, options) => {
        return get('/group/get_info', data, options)
    },
    // 添加部门
    addGroup: (data, options) => {
        return post('/group/add', data, options)
    },
    // 编辑部门
    editGroup: (data, options) => {
        return post('/group/edit', data, options)
    },
    // 移动部门
    moveGroup: (data, options) => {
        return post('/group/move', data, options)
    },
    // 删除部门
    deleteGroup: (data, options) => {
        return post('/group/delete', data, options)
    },
    // 获取成员列表
    getUserList: (data, options) => {
        return get('/group/get_user_list', data, options)
    },
    // 添加成员
    addUser: (data, options) => {
        return post('/user/add', data, options)
    },
    // 编辑成员
    editUser: (data, options) => {
        return post('/user/edit', data, options)
    },
    // 获取角色列表
    getRoleList:  (data, options) => {
        return get('/user/get_role_list', data, options)
    },
    //获取角色列表-列表页筛选 /user/
    getSearchRoleList:  (data, options) => {
        return get('/user/get_user_role_list_for_search', data, options)
    },
    // 获取部门成员列表
    getMemberList:  (data, options) => {
        return get('/user/get_detail_list', data, options)
    },
    // 获取成员详情
    getUserInfo:  (data, options) => {
        return get('/user/get_info', data, options)
    },
    // 重置成员密码
    resetPassword:  (data, options) => {
        return post('/user/reset_password', data, options)
    },
    // 禁用成员
    disableUser:  (data, options) => {
        return post('/user/disable', data, options)
    },
    // 获取禁用成员列表
    getDisabledUserList:  (data, options) => {
        return get('/user/get_disabled_list', data, options)
    },
    // 修改成员部门
    editUserGroup:  (data, options) => {
        return post('/user/edit_group', data, options)
    },
    // 修改成员部门数据权限
    editUserGroupDataAction:  (data, options) => {
        return post('/user/edit_group_data_action', data, options)
    },
    // 获取授权下拉成员列表
    getGroupTreeWithUser:  (data, options) => {
        return get('/group/get_tree_with_user', data, options)
    },
    // 授权
    userAuth:  (data, options) => {
        return post('/user/grant_auth', data, options)
    },
    // 获取授权下拉成员列表
    getAuthUserList:  (data, options) => {
        return get('/user/get_grant_user_list', data, options)
    },
    // 释放资源
    userRelease:  (data, options) => {
        return post('/user/release_perm', data, options)
    },
    // 获取释放资源详情
    getReleaseResourceDetail:  (data, options) => {
        return get('/user/get_release_resource_detail', data, options)
    },
    // 还原
    userRestore:  (data, options) => {
        return post('/user/restore', data, options)
    },
    // 企业微信id
    syncWeworkId:  (data, options) => {
        return post('/user/sync_wework_id', data, options)
    },
}
